import React from "react";
import _ from "lodash";

import { DescriptionOutlinedIcon } from "icons";
import { colors } from "theme/palette";
import { format, parseJSON } from "utils/datetime";

import Stack from "components/Stack";
import Text from "components/Text";

import { IPackageDetailsFieldValue } from "entities/Checklist/sdk";

export type IFilefieldCustomValue = Pick<
  IPackageDetailsFieldValue,
  "value_id" | "file"
> & {
  uploaded_at?: string;
  uploaded_by?: { email: string };
};
interface IPrintableFilesTable {
  customFieldValues: IFilefieldCustomValue[];
}

const PrintableFilesTable = ({ customFieldValues }: IPrintableFilesTable) => (
  <>
    {customFieldValues.map(({ file, uploaded_at, value_id, uploaded_by }) => (
      <React.Fragment key={value_id}>
        {!_.isNil(file) && (
          <Stack
            key={value_id}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
            sx={{
              padding: 0.5,
              borderBottom: `1px solid ${colors.blue20}`,
            }}
          >
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                maxWidth: "75%",
              }}
            >
              <DescriptionOutlinedIcon sx={{ width: "16px", height: "16px" }} />
              <Text
                noWrap
                variant="text4"
                sx={{ flex: 1 }}
                data-testid="uploaded-file-name"
              >
                {file?.original_file_name}
              </Text>
            </Stack>
            <Stack direction="row" spacing={3} alignItems="center">
              {uploaded_by && (
                <Text variant="text4" data-testid="file-uploaded-by">
                  {_.truncate(uploaded_by.email, { length: 40 })}
                </Text>
              )}
              <Text variant="text4" noWrap>
                {uploaded_at &&
                  format(parseJSON(uploaded_at), "MMM dd, yyyy, hh:mm a")}
              </Text>
            </Stack>
          </Stack>
        )}
      </React.Fragment>
    ))}
  </>
);

export default PrintableFilesTable;
